.root {
  position: relative;
  flex-shrink: 0;
  width: var(--play-button-size);
  height: var(--play-button-size);
  padding: 0;
  overflow: visible;
  color: var(--white);
  appearance: none;
  background: var(--primary-600);
  border-color: transparent;
  border-width: 0;
  border-radius: 100%;
  transition:
    all 0.25s,
    opacity 0.4s;
  will-change: transform;

  &[aria-disabled="true"] {
    &,
    &:hover,
    &:active,
    &:focus {
      cursor: not-allowed;
    }
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    height: 90%;
    opacity: 0;
    transform: translate(-50%, -50%);
    transform-origin: 50% 50%;
    transition: opacity 0.15s;

    &.visible {
      opacity: 1;
    }

    &.link {
      width: 50%;
      height: 50%;
      color: var(--white);
    }
  }
}

.hover {
  &:hover {
    transform: scale(1.125);

    .animation {
      display: none;
    }

    .pause {
      display: block;
    }
  }
}

.loading {
  background: var(--primary-dark);
}

.errored {
  background: var(--sentiment-negative);
}

.playing {
  background: var(--primary-dark);
}

.monochrome {
  & > * {
    color: var(--blue-darkdark);
  }
  background: var(--white);
}

.pause {
  display: none;
}
